import { update } from 'serializr';

export function transformHelper(transformedData, store): void {
    if (transformedData.type === 'update' && transformedData.items?.some((it) => it.points)) {
        transformedData.items.forEach((it, idx) => {
            const vehicle = store._map.get(it.id);

            if (vehicle) {
                transformedData.items[idx].driver = {
                    ...vehicle.driver,
                    ...transformedData.items[idx].driver
                };
                vehicle.points.splice(0, vehicle.points.length);
                update(store, transformedData);
            }
        });
    } else {
        update(store, transformedData);
    }
}
